import { render, staticRenderFns } from "./CDRQFileHolder.vue?vue&type=template&id=2898c722&scoped=true&"
import script from "./CDRQFileHolder.vue?vue&type=script&lang=ts&"
export * from "./CDRQFileHolder.vue?vue&type=script&lang=ts&"
import style0 from "./CDRQFileHolder.vue?vue&type=style&index=0&id=2898c722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898c722",
  null
  
)

export default component.exports